var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32289 9.60626C2.89237 9.12354 2.89237 8.3409 3.32289 7.85818C3.7534 7.37547 4.45141 7.37547 4.88192 7.85818L6.28506 9.43145C6.37116 9.52799 6.51076 9.52799 6.59687 9.43145L11.1181 4.36204C11.5486 3.87932 12.2466 3.87932 12.6771 4.36204C13.1076 4.84475 13.1076 5.62739 12.6771 6.11011L6.59687 12.9276C6.51076 13.0241 6.37116 13.0241 6.28506 12.9276L3.32289 9.60626Z",
    fill: "#743BBC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 1.5,
    stroke: "#743BBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checkedIcon.3415147b10b770af097e0bb217c3f8bb.svg";
export { ForwardRef as ReactComponent };